<template>
  <div class="right-bottom">
    <a-row class="count" :gutter="16">
      <a-col span="12">
        <div class="top item midu">
          <div class="stitle">泳池人数</div>
          <div class="num fx-led">{{ total }}</div>
        </div>
      </a-col>
      <a-col span="12">
        <div class="top item ligang">
          <div class="stitle">救生员离岗报警</div>
          <div class="num fx-led">{{ off_num }}</div>
        </div>
      </a-col>
      <a-col span="24">
        <div class="bottom item">
          <div class="stitle">泳客行为报警</div>
          <div class="num fx-led">{{ warning_num }}</div>
        </div>
      </a-col>
    </a-row>
    <div class="table">
      <div class="head">
        <div class="t-item">
          <span class="item no">编号</span>
          <span class="item type">报警类型</span>
          <span class="item con">报警信息</span>
          <span class="item time">报警时间</span>
        </div>
      </div>
      <div class="body">
        <div v-if="!list.length" class="empty">（空）</div>
        <div class="t-item" :class="{ warning: item.warning }" v-for="(item, index) in list" :key="index">
          <span class="item no">No.{{ index + 1 }}</span>
          <span class="item type">{{ item.type | type }}</span>
          <span class="item con">
            <a-tooltip placement="top" :title="item.message" :get-popup-container="getPopupContainer">
              <div class="message">{{ item.message }}</div>
            </a-tooltip>
          </span>
          <span class="item time">{{ item.created_time }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

let timer = null

export default {
  data() {
    return {
      list: [],
      off_num: 0,
      warning_num: 0,
      total: 0,
    }
  },
  filters: {
    type(val) {
      if (!val) return '- -'
      const arr = ['状态不佳', '离岗', '溺水', '泳客密度']
      return arr[val - 1]
    },
  },
  destroyed() {
    clearInterval(timer)
  },
  mounted() {
    this.get_data()
    this.get_number()

    timer = setInterval(() => {
      this.get_data()
      this.get_number()
    }, 10000)
  },
  computed: {
    ...mapState({
      sid: (state) => state.user.sid,
    }),
  },
  methods: {
    getPopupContainer(trigger) {
      return trigger.parentElement
    },
    get_number() {
      this.$http({
        url: '/stadium/pools',
        method: 'post',
        data: {
          sid: this.sid,
        },
      }).then((r) => {
        this.total = r[0].crowd_data.number
      })
    },
    get_data() {
      this.$http({
        url: '/stadium/alarm-list',
        method: 'post',
        data: {
          sid: this.sid,
        },
      }).then((r) => {
        const list = []
        let off_num = 0
        let warning_num = 0
        r.forEach((row) => {
          if (row.type == 3) {
            warning_num++
            row.warning = true
            list.push(row)
          } else {
            if (row.type == 2) {
              off_num++
            }
            list.push(row)
          }
        })
        this.list = list
        this.off_num = off_num
        this.warning_num = warning_num
      })
    },
  },
}
</script>

<style lang="less" scoped>
.right-bottom {
  color: #fff;
  padding: 0 20px;
  .count {
    margin-top: 8px;
    .top {
      height: 112px;
      &.midu {
        background: url(../../assets/dongti/midu.png) no-repeat center center/100% 100%;
      }
      &.ligang {
        background: url(../../assets/dongti/ligang.png) no-repeat center center/100% 100%;
      }
    }
    .bottom {
      height: 120px;
      margin-top: 8px;
      background: url(../../assets/dongti/yongke.png) no-repeat center center/100% 100%;
    }
    .item {
      position: relative;
      .stitle {
        font-size: 14px;
        color: #5ce3ff;
        position: absolute;
        right: 18px;
        top: 10px;
      }
      .num {
        width: 60px;
        text-align: center;
        font-size: 36px;
        color: #f5b401;
        position: absolute;
        top: 32px;
        right: 15px;
      }
    }
  }
  .table {
    margin-top: 8px;
    .head {
      padding: 10px;
      background: #046d93;
      border: 1px solid #288fb4;
    }
    .body {
      padding: 8px 10px;
      background: #0a4066;
      overflow: auto;
      height: 236px;
      .empty {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .t-item {
        padding: 8px 0;
        &:nth-of-type(even) {
          background: #002a48;
        }
        &.warning {
          background: #190101;
          color: #e02020;
        }
      }
    }
    .t-item {
      display: flex;
      align-items: center;
      .item {
        display: inline-block;
        text-align: center;
        &.no {
          width: 20%;
        }
        &.type {
          width: 20%;
        }
        &.con {
          width: 25%;
          .message {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        &.time {
          width: 35%;
        }
      }
    }
  }
}
</style>
